import React from "react";
import StatusCard from "../../SharedComponents/StatusCard/StatusCard";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { getScrollBarAppState } from "orion-components/AppState/Global/selectors";

const StatusBoard = ({ canManage }) => {
	const locale = useSelector(state => state.i18n.locale);
	const statusCards = useSelector(state => state.statusCards && state.statusCards.cards);
	const dir = useSelector(state => getDir(state));
	const orgId = useSelector(state => state.session.user.profile.orgId);
	const scrollBarsEnabled = useSelector(state => getScrollBarAppState(state));
	const sortedStatusCards = [...statusCards].sort((a, b) =>
		a.name.localeCompare(b.name, locale, { sensitivity: "base" })
	);
	return (
		<div
			style={{
				overflow: "scroll",
				height: "calc(100% - 80px)",
				width: scrollBarsEnabled ? "95%" : "90%",
				...(!scrollBarsEnabled && { margin: "auto" }),
				...(scrollBarsEnabled && { marginLeft: "auto" })
			}}
		>
			{sortedStatusCards.map((card, index) => {
				return (
					card.global && (
						<div className="globalStatusCard" style={{ marginBottom: 20 }}>
							<StatusCard
								key={card.id}
								index={index}
								card={card}
								disableControls={orgId !== card.ownerOrg && !canManage}
								disableMenu={false}
								userCanEdit={canManage}
								userCanShare={false}
								dir={dir}
								locale={locale}
							/>
						</div>
					)
				);
			})}
		</div>
	);
};

export default StatusBoard;
